export default __webpack_public_path__ + "static/media/imgActivity8-8.78467c1d.png";